// Trims
export const SET_TRIMS = 'SET_TRIMS';



// WEBPACK FOOTER //
// ./src/store/reducers/trims/actionTypes.js